export const en = {
    fill_your_en_data: 'Please do not forget to add your first and last name in English in the personal information block',
    choose_seats_available: 'Seat selection is available for this flight. For more information, write to your travel chat',
    reservation: 'Reserved until {date} • The ticket will be issued after the approval of the business trip',
};
